module.exports = __webpack_public_path__ + "static/media/9.46fd94ac.jpg";